import { render, staticRenderFns } from "./group-bulk-ivr-composer.vue?vue&type=template&id=4a21dfa6&scoped=true"
import script from "./group-bulk-ivr-composer.vue?vue&type=script&lang=js"
export * from "./group-bulk-ivr-composer.vue?vue&type=script&lang=js"
import style0 from "./group-bulk-ivr-composer.vue?vue&type=style&index=0&id=4a21dfa6&prod&lang=scss&scoped=true"
import style1 from "./group-bulk-ivr-composer.vue?vue&type=style&index=1&id=4a21dfa6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a21dfa6",
  null
  
)

export default component.exports